import {EsquireClient} from "@/types/clients/esquire";
import OptionData, {IOptionData} from "@/types/clients/esquire/data/general/contract-data/option";
import { excludeCleaningSupplyOptions } from "@/services/cleaning-supplies-service";

export interface IContractOptionsResponse {
  contract_id: string;
  options: IOptionData[];
}

export type ContractOptionsMap = Record<string, OptionData[]>;

export default class GetReservationOptions {
  constructor(private client: EsquireClient) {}

  public async send(): Promise<ContractOptionsMap> {
    const url = await this.client.fetchUrlFromSession("get-reservation-options");

    const response = await this.client.fetch(
      () => new URL(url),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      throw new Error("Failed to fetch reservation options");
    }

    const raw = (await response.json()) as IContractOptionsResponse[];

    const map: ContractOptionsMap = {};

    raw.forEach((item: IContractOptionsResponse): void => {
      map[item.contract_id] = excludeCleaningSupplyOptions(
        item.options.map((opt: IOptionData): OptionData => new OptionData(opt))
      );
    });

    return map;
  }
}
